import domready from 'domready';

domready(() => {
  const $wrapper = $(document);
  const $stripeContainer = $wrapper.find('#stripe-container');
  if (typeof Stripe !== 'undefined' && $stripeContainer.length > 0) {
    window.stripe = Stripe($stripeContainer.data('publishable-key'));
  }
});
